import PropTypes from "prop-types";
import { createContext, useState } from "react";

import { Toast } from "@features/ui";

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState();
  const contextValue = {
    toast,
    setToast,
    onClose: () => setToast(),
    closable: true,
    className: "",
  };

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <div className="app-toast-container">
        <Toast
          open={!!toast}
          message={toast?.message}
          onClose={() =>
            contextValue.onClose ? contextValue.onClose() : setToast()
          }
          type={toast?.type}
          closable={contextValue.closable}
          className={contextValue.className}
        />
      </div>
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node,
};
